<template>
  <div
    v-if="projectStore.modelsStats.uploading && y > 0.6 * height"
    class="flex right-6 sm:w-[230px] px-2 h-12 rounded-[21px] items-center"
  >
    <Upload class="mx-2 text-primary" />
    <div v-if="width > 640" class="flex flex-wrap w-full mr-2 items-center justify-between">
      <span>
        {{ `In progress (${projectStore.modelsStats.uploaded}/${projectStore.modelsList.length})` }}
      </span>
      <LinearLoader class="h-1 w-40" />
    </div>
    <div v-else>
      <span>
        {{ `${projectStore.modelsStats.uploaded}/${projectStore.modelsList.length}` }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import LinearLoader from '@/components/ui/linear-loader/LinearLoader.vue';
import { useWindowScroll, useWindowSize } from '@vueuse/core';
import { Upload } from 'lucide-vue-next';

const { width, height } = useWindowSize();
const { y } = useWindowScroll();

const projectStore = useProjectStore();
</script>
